import React, { useEffect, useMemo } from 'react';
import { Link, Navigate, useLocation } from 'react-router-dom';
import Header from '../components/Header';
import Footer from '../components/Footer';

const BookingPage = () => {
  const location = useLocation();
  const cameFromPitch = location.state && location.state.fromPitch;

  // Resolve user_id from state, URL params, or localStorage
  const resolvedUserId = useMemo(() => {
    const stateId = location.state && location.state.userId;
    if (stateId) return stateId;
    try {
      const params = new URLSearchParams(window.location.search);
      const urlId = params.get('user_id') || params.get('userid') || params.get('userId') || params.get('client_reference_id');
      if (urlId) return urlId;
    } catch (_) {}
    try {
      const stored = localStorage.getItem('user_id');
      return stored || null;
    } catch (_) {
      return null;
    }
  }, [location.state]);

  // Load Calendly widget script and persist user_id if present
  useEffect(() => {
    const script = document.createElement('script');
    script.src = 'https://assets.calendly.com/assets/external/widget.js';
    script.async = true;
    document.body.appendChild(script);

    if (resolvedUserId) {
      try { localStorage.setItem('user_id', resolvedUserId); } catch (_) {}
    }

    return () => {
      // Cleanup script on component unmount
      const existingScript = document.querySelector('script[src="https://assets.calendly.com/assets/external/widget.js"]');
      if (existingScript) {
        document.body.removeChild(existingScript);
      }
    };
  }, [resolvedUserId]);

  const calendlyBaseUrl = 'https://calendly.com/autonomerly/call';
  const calendlyUrl = useMemo(() => {
    return resolvedUserId
      ? `${calendlyBaseUrl}?user_id=${encodeURIComponent(resolvedUserId)}`
      : calendlyBaseUrl;
  }, [resolvedUserId]);

  if (!cameFromPitch) {
    return <Navigate to="/sales-pitch-onsite-call-from-ai" replace />;
  }

    return (
      <div className="booking-page">
      <style>{`
        /* Increase Calendly widget font sizes */
        .calendly-inline-widget {
          font-size: 16px !important;
        }
        .calendly-inline-widget * {
          font-size: 16px !important;
        }
        .calendly-inline-widget .calendly-event-details,
        .calendly-inline-widget .calendly-event-details * {
          font-size: 18px !important;
        }
        .calendly-inline-widget .calendly-time-slots,
        .calendly-inline-widget .calendly-time-slots * {
          font-size: 16px !important;
        }
        .calendly-inline-widget .calendly-time-slot {
          font-size: 16px !important;
          padding: 12px !important;
        }
        .calendly-inline-widget .calendly-form {
          font-size: 16px !important;
        }
        .calendly-inline-widget .calendly-form input,
        .calendly-inline-widget .calendly-form textarea,
        .calendly-inline-widget .calendly-form select {
          font-size: 16px !important;
          padding: 12px !important;
        }
        .calendly-inline-widget .calendly-button {
          font-size: 18px !important;
          padding: 16px 24px !important;
        }
        .calendly-inline-widget .calendly-title {
          font-size: 24px !important;
        }
        .calendly-inline-widget .calendly-description {
          font-size: 18px !important;
        }
      `}</style>
      <Header />
      
  <div style={{paddingTop: '80px', minHeight: '100vh', backgroundColor: '#eef2f5'}}>
        <div className="container" style={{padding: '40px 20px'}}>
          
          <div style={{textAlign: 'center', marginBottom: '40px'}}>
            <h1 style={{marginBottom: '16px', color: '#1a1a1a', fontWeight: 'bold'}}>Activate Your AI Agents</h1>
            <p style={{fontSize: '1.125rem', color: '#6b7280', maxWidth: '1000px', margin: '0 auto', lineHeight: '1.6'}}>
              Schedule your AI activation session. In under 30 minutes we decide which agents to turn on,<br />
              configure your workflow, and map your first 14‑day ROI milestones.
            </p>
          </div>

          {/* Calendly Embed */}
            <div style={{
              backgroundColor: 'white',
              borderRadius: '16px',
            padding: '20px',
            boxShadow: '0 4px 6px -1px rgb(0 0 0 / 0.1)',
            maxWidth: '1400px',
            margin: '0 auto'
          }}>
            <div 
              className="calendly-inline-widget" 
              data-url={calendlyUrl}
              style={{minWidth: '1200px', height: '800px', width: '100%'}}
            ></div>
          </div>

          <div style={{textAlign: 'center', marginTop: '40px'}}>
            <Link to="/" className="btn btn-secondary">
              ← Back to Home
            </Link>
          </div>
        </div>
      </div>
      
      <Footer />
    </div>
  );
};

export default BookingPage;
